export const findMatchingVariant = ({
  variants,
  optionCodes,
  optionSelections,
}) => {
  return variants.find(({ attributes, product }) => {
    const customAttributes = (attributes || []).reduce(
      (map, { code, value_index }) => new Map(map).set(code, value_index),
      new Map()
    );

    for (const [id, value] of optionSelections) {
      const code = optionCodes.get(id);
      const matchesStandardAttribute = product[code] === value;
      const matchesCustomAttribute = customAttributes.get(code) === value;

      if (!matchesStandardAttribute && !matchesCustomAttribute) {
        return false;
      }
    }

    return true;
  });
};
